import Input from '../input';
import Dropdown, {DropdownItem, DropdownMenu} from '../dropdown';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {
    data, className, style, value, trigger,
    changeOnSelect, format, filterable,
    keywords, _show,
} = self.get();

const labelObj = {
    label: null,
    labels: [],
    values: [],
};

let hasData = false;

const Options = (props) => {
    const data = props.data || [];
    const level = props.level;
    const parentShowed = props.parentShowed;
    const parentActived = props.parentActived;
    const parentSelected = props.parentSelected;
    const ret = [];

    // show loading
    if (!data.length) {
        if (!props.loaded) {
            return h('i', null, null, 'ion-load-c icon-loading')
        } else {
            return h('div', null, '无数据', 'k-no-data')
        }
    }

    data.forEach((item, index) => {
        const {active, selected} = self.handleProps(item, labelObj, level, parentActived, parentSelected);

        const Item = () => {
            const events = {};
            events['ev-click'] = self._onClick.bind(self, item, level);
            if (trigger === 'hover') {
                events['ev-mouseenter'] = self._onClick.bind(self, item, level);
            }
            if (!changeOnSelect) {
                events['ev-select'] = self._onSelect;
            }

            return (
                h(DropdownItem, {
        'disabled': function() {try {return (item.disabled )} catch(e) {_e(e)}}.call($this),
        'className': _className(function() {try {return ({'k-active': active} )} catch(e) {_e(e)}}.call($this)),
        ...function() {try {return (events )} catch(e) {_e(e)}}.call($this),
        'children': [
            function() {try {return (item.template ? item.template(item, index) : item.label )} catch(e) {_e(e)}}.call($this),
            function() {try {return (item.children )} catch(e) {_e(e)}}.call($this) ?
                h('i', null, null, 'k-arrow ion-ios-arrow-right') :
                undefined
        ],
        '_context': $this
    })
            );
        };

        const show = parentShowed && active;
        ret.push(
            !item.children ? 
                h(Item, {
        '_context': $this
    }) :
                h(Dropdown, {
        'position': function() {try {return ({my: 'left top', at: 'right top', collisionDirection: ['left']} )} catch(e) {_e(e)}}.call($this),
        'of': 'parent',
        'disabled': function() {try {return (item.disabled )} catch(e) {_e(e)}}.call($this),
        'trigger': function() {try {return (trigger )} catch(e) {_e(e)}}.call($this),
        'value': function() {try {return (show )} catch(e) {_e(e)}}.call($this),
        'children': [
            h(Item, {
                '_context': $this
            }),
            h(DropdownMenu, {
                'className': _className(function() {try {return ({
                            "k-select-dropdown": true,
                            "k-cascader-dropdown": true,
                        } )} catch(e) {_e(e)}}.call($this)),
                'children': function() {try {return (show || selected
                            )} catch(e) {_e(e)}}.call($this) ?
                    h(Options, {
                        'data': function() {try {return (item.children )} catch(e) {_e(e)}}.call($this),
                        'level': function() {try {return (level + 1 )} catch(e) {_e(e)}}.call($this),
                        'parentShowed': function() {try {return (show )} catch(e) {_e(e)}}.call($this),
                        'loaded': function() {try {return (item.loaded )} catch(e) {_e(e)}}.call($this),
                        'parentActived': function() {try {return (active )} catch(e) {_e(e)}}.call($this),
                        'parentSelected': function() {try {return (selected )} catch(e) {_e(e)}}.call($this),
                        '_context': $this
                    }) :
                    undefined,
                '_context': $this,
                'ev-show': function() {try {return (self._onSubMenuShow.bind(self, item) )} catch(e) {_e(e)}}.call($this)
            })
        ],
        '_context': $this
    })
        );
    });

    return ret;
}

let Menu
if (!filterable || !keywords) {
    Menu = (
        h(DropdownMenu, {
        'ref': function(i) {widgets['cascader'] = i},
        'className': _className(function() {try {return ({
                "k-select-dropdown": true,
                "k-cascader-dropdown": true,
            } )} catch(e) {_e(e)}}.call($this)),
        'key': 'cascader',
        'children': h(Options, {
            'data': function() {try {return (data )} catch(e) {_e(e)}}.call($this),
            'level': function() {try {return (0 )} catch(e) {_e(e)}}.call($this),
            'parentShowed': function() {try {return (_show )} catch(e) {_e(e)}}.call($this),
            'loaded': function() {try {return (true )} catch(e) {_e(e)}}.call($this),
            'parentActived': function() {try {return (true )} catch(e) {_e(e)}}.call($this),
            'parentSelected': function() {try {return (true )} catch(e) {_e(e)}}.call($this),
            '_context': $this
        }),
        '_context': $this,
        'ev-$change:value': function() {try {return (self._onChangeShow )} catch(e) {_e(e)}}.call($this)
    })
    );
} else {
    Menu = (
        h(DropdownMenu, {
        'ref': function(i) {widgets['menu'] = i},
        'className': _className(function() {try {return ({
                "k-select-dropdown": true,
                "k-cascader-filterable-dropdown": true, 
            } )} catch(e) {_e(e)}}.call($this)),
        'key': 'filterable',
        'children': function() {try {return ((() => {
                const items = self._filter();
                if (!items.length) return h('div', null, '无匹配数据', 'k-no-data')
                return __m(function() {try {return (items )} catch(e) {_e(e)}}.call($this), function(value, key) {
            return h(DropdownItem, {
                'disabled': function() {try {return (value.disabled )} catch(e) {_e(e)}}.call($this),
                'children': function() {try {return (do {
                    // highlight keywords
                    const label = value.map(item => item.label).join(' / ');
                    const labels = label.split(keywords);
                    const length = labels.length; 
                    labels.map((item, index) => {
                        const ret = [item];
                        if (index !== length - 1) {
                            ret.push(h('em', null, function() {try {return (keywords )} catch(e) {_e(e)}}.call($this)));
                        }
                        return ret;
                    });
                } )} catch(e) {_e(e)}}.call($this),
                '_context': $this,
                'ev-select': function() {try {return (self._selectByFilter.bind(self, value) )} catch(e) {_e(e)}}.call($this)
            });
        }, $this)
            })() )} catch(e) {_e(e)}}.call($this),
        '_context': $this,
        'ev-$changed:value': function() {try {return (self._position )} catch(e) {_e(e)}}.call($this),
        'ev-$change:value': function() {try {return (self._onChangeShow )} catch(e) {_e(e)}}.call($this)
    })
    )
}

labelObj.label = blocks.format ? 
    (_blocks['format'] = function(parent) {
        return function() {try {return (do {
        labelObj.values.map(value => value.label).join(' / ')
    } )} catch(e) {_e(e)}}.call($this);
    }) && (__blocks['format'] = function(parent) {
        var args = arguments;
        return blocks['format'] ? blocks['format'].apply($this, [function() {
            return _blocks['format'].apply($this, args);
        }].concat(__slice.call(args, 1))) : _blocks['format'].apply($this, args);
    }) && __blocks['format'].apply($this, [__noop].concat(function() {try {return ([labelObj.values] )} catch(e) {_e(e)}}.call($this))) : 
    format.call(this, labelObj.values);

    return (function() {
        var _obj = {
            'Menu': function() {try {return (Menu )} catch(e) {_e(e)}}.call($this),
            'className': 'k-cascader',
            'labelObj': function() {try {return (labelObj )} catch(e) {_e(e)}}.call($this)
        };
        return parent.call($this, _obj, _Vdt, blocks, parent)
    }).call($this)
}